import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import IServerAlertRule from 'features/server/model/ServerAlertRule/IServerAlertRule';

import ServerAlertRuleForm from './ServerAlertRuleForm/ServerAlertRuleForm';

interface IServerAlertRuleModalProps {
    open: boolean,
    item?: IServerAlertRule,
    presetServerUuid?: string,
    handleClose: () => void,
}

const ServerAlertRuleModal: React.FC<IServerAlertRuleModalProps> = ({open, item, presetServerUuid, handleClose}) => {
    const isNew = !item;

    return (
        <MainModal
            header={isNew ? t`Создание правила` : t`Редактирование правила`}
            open={open}
            handleClose={handleClose}
            size="md"
        >
            <ServerAlertRuleForm
                item={item}
                presetServerUuid={presetServerUuid}
                onSuccess={handleClose}
                onClose={handleClose}
            />
        </MainModal>
    );
};

export default ServerAlertRuleModal;
